class Visit {
    constructor(block) {
        this.container = block?.querySelector(".section--promo__content");
        this.map = block?.querySelector("div.section--image");
        this.text = block?.querySelector("div.section--text");

        this.isMobile = window.matchMedia(`(max-width: 768px)`).matches;

        if (this.isMobile && this.container && this.map && this.text) {
            // swap order. Show map first, then text.
            this.container.insertBefore(this.map, this.text);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const visitBlocks = document.querySelectorAll(
        `.section.section--promo[data-type="visit"]`,
    );

    visitBlocks.forEach((input) => {
        new Visit(input);
    });
});

export default Visit;
